import Request from '../../utils/request'

export const CategoryServer = {
    getCategoryData(id: number) {
        return Request.$get(`/account/api_category_lecture_info?category=${id}`, {})
    },
    getCategoryListItem(params: {category: number, p: number}) {
        return Request.$get('/account/api_get_starting_lecture', {params})
    },
    getCategoryRecommendData(params: {category: number, p: number}) {
        return Request.$get(`/account/api_get_category_lecture`, {params})
    },
    getCategoryRecommendAllData(id: number) {
        return Request.$get(`/api/category/get_feed?pid=${id}`, {})
    },
    getCategoryRecommendBottomMenu() {
        return Request.$get('/api/index/get_first_categories', {})
    }
}

export default CategoryServer



// WEBPACK FOOTER //
// ./src/services/Modules/categoryServer.ts